import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { AuthActions } from 'src/redux/actions/constant';
import authService from 'src/services/apiServices/authService';

const {
  AUTO_GENERATE_PASSWORD,
  AUTO_GENERATE_PASSWORD_FAILURE,
  AUTO_GENERATE_PASSWORD_RESET,
  AUTO_GENERATE_PASSWORD_SUCCESS,
  AUTO_GENERATE_PASSWORD_LOADING,
} = AuthActions;

function* autoGeneratePassword(): SagaReturnType<any> {
  try {
    yield put({ type: AUTO_GENERATE_PASSWORD_LOADING });
    const response = yield call(authService.getGeneratedPassword);
    if (response?.status === 200) {
      yield put({ type: AUTO_GENERATE_PASSWORD_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: AUTO_GENERATE_PASSWORD_FAILURE, payload: error });
  }
}

function* autoGeneratePasswordSaga() {
  yield takeEvery(AUTO_GENERATE_PASSWORD, autoGeneratePassword);
}

export default autoGeneratePasswordSaga;
